export default "__VITE_ASSET__D185plDA__"